import React from "react";
import ReactDOM from "react-dom/client";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import App from "./App";

const DEFAULT_UMAMI_WEBSITE_ID = "6e2c6ccf-6d14-46dd-8d6a-54602e6d44cb";

function setupUmami() {
  try {
    if (navigator.doNotTrack === "1") return;
    const websiteId = (import.meta.env.VITE_UMAMI_WEBSITE_ID || DEFAULT_UMAMI_WEBSITE_ID || "").trim();
    if (!websiteId) return;
    if (document.querySelector('script[data-umami-proxy="1"]')) return;
    const s = document.createElement("script");
    s.defer = true;
    s.src = "/a/script.js";
    s.setAttribute("data-website-id", websiteId);
    s.setAttribute("data-host-url", "/a");
    s.setAttribute("data-umami-proxy", "1");
    document.head.appendChild(s);
  } catch {
    // Never block app rendering because of analytics setup.
  }
}

setupUmami();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
    <Analytics />
    <SpeedInsights />
  </React.StrictMode>
);
